import React, { useState, useEffect } from 'react';
import styles from '../../App.module.scss';
import { useNavigate } from 'react-router-dom';
import GavinM from '../assets/GavinM5.png';
import HeroStatement from '../components/heroStatement';
/*
import appleIcon from '../assets/appleIcon.png';
import typeScriptLogo from '../assets/typescript.png';
import javascriptLogo from '../assets/javascriptLogo.png';
import kotlinLogo from '../assets/kotlinLogo.png';
import swiftLogo from '../assets/swiftLogo.png';
import blockchainIcon from '../assets/blockchainLogo.png';
import htmlLogo from '../assets/htmlLogo.png';
import androidLogo from '../assets/androidLogo.png';
import solanaLogo from '../assets/solanaLogo.png';
import metamaskLogo from '../assets/metamaskLogo.png';
import cPlusPlusLogo from '../assets/cPlusPlusLogo.webp';
import awsLogo from '../assets/awsLogo.png';
import reactLogo from '../assets/reactLogo.png';
import pythonLogo from '../assets/pythonLogo.png';
import adobeLogo from '../assets/adobeLogo.png';
import AdobeIcon from '../assets/AdobeIcon.png';
import figmaLogo from '../assets/figmaLogo.png';
import bitcoin from '../assets/bitcoin.png';
import javaLogo from '../assets/javaLogo.png';
import designIcon from '../assets/designIcon.png';
import dockerLogo from '../assets/dockerLogo.png';
import lockIcon from '../assets/lockIcon.png';
*/

import Education from '../components/education';
import ExperienceSection from '../components/experienceSection';
import Contact from '../components/contact';
import References from '../components/references';
import Header from '../components/header';

export default function Home() {

    const isSmallScreen = window.innerWidth <= 750;

    const navigate = useNavigate();
    
    const [showToolBeltToolTip, setshowToolBeltToolTip] = useState(false);

    const isMobile = window.innerWidth <= 768;

    const [nameClass, setNameClass] = useState('hidden');
    const [imageClass, setImageClass] = useState('hidden');

    useEffect(() => {
        // Trigger the animations when the component mounts
        setTimeout(() => {
            setNameClass('slide-in-left');
            setImageClass('slide-in-right');
        }, 100); // Small delay to start the animation
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  


  return (
      
    <div style={{ overflowX: 'hidden', maxWidth: '100vw', width: '100%' }}>
      <Header />

    <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: isSmallScreen ? '100vh' : 0,
        overflow: isSmallScreen ? 'hidden' : 'visible', 
        width: '100vw', 
        maxWidth: '100vw',
        pointerEvents: 'none',
        zIndex: 2
    }}>

        {/* Moving background */}

        {isSmallScreen ? (
            <>
        <div className='homepage-animation-square-one-small'
        ></div>
        <div className='homepage-animation-square-two-small'
        ></div>
        <div className='homepage-animation-square-one-dot-one-small'
        ></div>

            </>
        ) : (
            <>
        <div className='homepage-animation-square-one-large'
        ></div>
        <div className='homepage-animation-square-two-large'
        ></div>
        <div className='homepage-animation-square-one-dot-one-large'
        ></div>
            </>

        )}
        <div className='homepage-animation-square-one'
        ></div>
        <div className='homepage-animation-square-two'
        ></div>
        <div className='homepage-animation-square-three'
        ></div>
        <div className='homepage-animation-square-three-dot-one'
        ></div>
        <div className='homepage-animation-square-four'
        ></div>
        <div className='homepage-animation-square-five'
        ></div>
        <div className='homepage-animation-square-six'
        ></div>
        {/* Animated squares to fill whitespace - positioned to not affect layout */}
        <div className='homepage-animation-square-seven'
        ></div>
        <div className='homepage-animation-square-eight'
        ></div>
        <div className='homepage-animation-square-nine'
        ></div>
        {/* Bottom half animated squares - commented out for shorter page */}
        {/* <div className='homepage-animation-square-ten'
        ></div>
        <div className='homepage-animation-square-eleven'
        ></div>
        <div className='homepage-animation-square-twelve'
        ></div>
        <div className='homepage-animation-square-thirteen'
        ></div>
        <div className='homepage-animation-square-fourteen'
        ></div>
        <div className='homepage-animation-square-fifteen'
        ></div>
        <div className='homepage-animation-square-sixteen'
        ></div>
        <div className='homepage-animation-square-one-dot-one'
        ></div> */}
        </div>

        <div id="home-section" style={{ width: '100vw', 
            height: isSmallScreen ? '100vh' : '100vh', 
            display: 'flex',
            flexDirection: isSmallScreen ? 'column' : 'row', 
            marginTop: isSmallScreen ? '70px' : '0px',
            alignItems: 'center',
            justifyContent: 'space-around',
            zIndex: 10
            }}>


        <div style={{display: 'flex', flexDirection: 'column', gap: '30px', color: '#333333',  
        marginLeft: isSmallScreen ? '0px' : '0px',
        zIndex: 10  }}>

            <HeroStatement/>

            </div>
            <img
                src={GavinM}
                className={imageClass}
                alt="Photo of Gavin"
                style={{
                    marginTop: isSmallScreen ? '50px' : '0px',
                    width: isSmallScreen ? '48vw' : '28vw',
                    maxWidth: 'min(400px, 40vh)',
                    height: 'auto',
                    borderRadius: '10%',
                    marginRight: isSmallScreen ? '0px' : '10px',
                    zIndex: 10,
                    boxShadow: '0px 4px 6px rgba(0, 0.1, 0.1, 0.5)',
                    transform: 'scaleX(-1)' // Flip the image horizontally
                }}
            />
        </div>



        <ExperienceSection/>

        <Education/>

        <References/>

        <Contact/>


    </div>
  );
}